import { Grid } from "@mui/material";
import SpecialistPersonalInfo from "./SpecialistPersonalInfo";
import SpecializationInfo from "./SpecializationInfo";
import GraduationInfo from "./GraduationInfo";
import TaxesInfo from "./TaxesInfo";

const SaveForm = ({ foundUserInfo, isClinical, specializationInfo, graduationInfo }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <SpecialistPersonalInfo foundUserInfo={foundUserInfo} />
      <SpecializationInfo
        isClinical={isClinical}
        specializationInfo={specializationInfo}
      />
      <GraduationInfo graduationInfo={graduationInfo} />
      {!isClinical && <TaxesInfo />}
    </Grid>
  );
};

export default SaveForm;
